import { type FillApplyEvent } from '../events/types';
import { type SelectionState } from '../state/types';

import { type ReducerResponse } from './types';
import { calculateFillRange } from './utils/fill/calculate-fill-range';

/**
 * Confirms the active fill gesture and emits the source/target ranges for the
 * mutation effect. Selection state is unchanged; a missing source range is an
 * intentional noop.
 */
export function fillApplyReducer(
  state: SelectionState,
  event: FillApplyEvent
): ReducerResponse {
  const sourceRange = state.selections[state.selections.length - 1];

  if (!sourceRange) {
    return { next: state, delta: { kind: 'noop' } };
  }

  const fillRange = calculateFillRange(sourceRange, event.cell);

  return {
    next: {
      ...state,
      lastInteractionSource: event.source
    },
    delta: {
      kind: 'fillApplied',
      source: event.source,
      sourceRange,
      fillRange
    }
  };
}
